module.exports = __webpack_public_path__ + "static/media/insurance-auto-640.7d613720.jpg";